export const mortgageSurvey = {
  'mortgage_survey.loading': 'Načítání formuláře...',

  'mortgage_survey.load_confirm.title':
    'Chcete pokračovat v rozpracovaném formuláři?',
  'mortgage_survey.load_confirm.subtitle':
    'Máte rozpracovaný formulář na hypotéku, chcete v něm pokračovat nebo začít znovu?',
  'mortgage_survey.load_confirm.cancel': 'Začít znovu',
  'mortgage_survey.load_confirm.continue': 'Pokračovat',

  'mortgage_survey.load_confirm.keys.type': 'Nemovitost',
  'mortgage_survey.load_confirm.keys.budget': 'Rozpočet/cena nemovitosti',
  'mortgage_survey.load_confirm.keys.amount': 'Výše úvěru',
  'mortgage_survey.load_confirm.keys.percentage': 'Výše úvěru v %',
  'mortgage_survey.load_confirm.keys.district': 'Okres',

  'mortgage_survey.load_confirm.price': '{price} Kč',

  'mortgage_survey.steps.type.title': 'Na co chcete hypotéku?',
  'mortgage_survey.steps.type.looking_for_estate': 'Hledám nemovitost ke koupi',
  'mortgage_survey.steps.type.already_have_estate':
    'Mám vybranou nemovitost ke koupi',

  'mortgage_survey.steps.budget.title': 'Kolik stojí nemovitost?',
  'mortgage_survey.steps.budget.looking.title':
    'Jaký chcete mít rozpočet na koupit?',
  'mortgage_survey.steps.budget.label': 'Cena nemovitosti',
  'mortgage_survey.steps.budget.looking.label': 'Zadejte rozpočet',
  'mortgage_survey.steps.budget.positive': 'Zadejte prosím kladné číslo',
  'mortgage_survey.steps.budget.required': 'Vyplňte prosím částku',

  'mortgage_survey.steps.amount.title': 'Kolik si chcete půjčit?',
  'mortgage_survey.steps.amount.label': 'Výše úvěru',
  'mortgage_survey.steps.amount.required': 'Vyplňte prosím výši úvěru',
  'mortgage_survey.steps.amount.min': 'Výše úvěru musí být alespoň 200 000 kč',
  'mortgage_survey.steps.amount.max':
    'Výše úvěru nesmí být výšší než hodnota nemovitosti ({budget} kč)',
  'mortgage_survey.steps.amount.percentage.90%': '90%',
  'mortgage_survey.steps.amount.percentage.80%': '80%',
  'mortgage_survey.steps.amount.percentage.60%': '60%',
  'mortgage_survey.steps.amount.percentage.50%': '50%',
  'mortgage_survey.steps.amount.percentage.other': 'Jiné',

  'mortgage_survey.steps.district.title': 'Kde chcete hypotéku řešit?',
  'mortgage_survey.steps.district.label': 'Zadejte okres',
  'mortgage_survey.steps.district.required': 'Vyberte prosím okres',

  'mortgage_survey.steps.contact.title':
    'Pro získání nejvýhodnější úrokové sazby zadejte kontaktní údaje',
  'mortgage_survey.steps.contact.cta.next': 'Získat nejvýhodnější úrok',

  'mortgage_survey.steps.contact.fullname': 'Jméno a příjmení',
  'mortgage_survey.steps.contact.fullname.required':
    'Vyplňte prosím vaše celé jméno.',
  'mortgage_survey.steps.contact.email': 'E-mail',
  'mortgage_survey.steps.contact.email.required': 'Vyplňte prosím váš e-mail',
  'mortgage_survey.steps.contact.phone': 'Telefon',
  'mortgage_survey.steps.contact.phone.required': 'Vyplňte prosím váš telefon',
  'mortgage_survey.steps.contact.phone.valid':
    'Vyplňte prosím platný telefon (např. ve tvaru 777888999, nebo +420 777 888 999)',
  'mortgage_survey.steps.contact.text':
    'Odesláním formuláře souhlasím s <terms>obchodními podmínkami</terms> a se <gdpr>zpracováním osobních údajů</gdpr>.',

  'mortgage_survey.steps.contact.submit.error':
    'Při odesílání formuláře došlo k chybě, zkuste to prosím znovu později.',
};
